// React Basic and Bootstrap
import React from "react"
import { Container, Row } from "reactstrap"

//Import Components
import SectionTitle from "../../components/Shared/SectionTitle"
import TeamBox from "./TeamBox"

import { graphql, useStaticQuery } from "gatsby"

const Services = () => {
  const data = useStaticQuery(graphql`
    {
      services: markdownRemark(
        frontmatter: { contentKey: { eq: "academyPage" } }
      ) {
        frontmatter {
          meet_your_instructor {
            header
            sub_header
            name_of_instructor
            title_of_instructor
            instructor_image {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
      social_media_links: markdownRemark(
        frontmatter: { contentKey: { eq: "siteSettings" } }
      ) {
        frontmatter {
          social_media {
            facebook
            twitter
            linkedin
          }
        }
      }
    }
  `)

  const {
    header,
    sub_header,
    name_of_instructor,
    title_of_instructor,
    instructor_image,
  } = data.services.frontmatter.meet_your_instructor

  const {
    facebook: facebook_link,
    twitter: twitter_link,
    linkedin: linkedin_link,
  } = data.social_media_links.frontmatter.social_media

  const candidates = [
    {
      id: 1,
      image: instructor_image,
      name: name_of_instructor,
      designation: title_of_instructor,
      link: "/",
      socialIds: [
        { icon: "facebook", link: facebook_link },
        { icon: "twitter", link: twitter_link },
        { icon: "linkedin", link: linkedin_link },
      ],
    },
  ]

  return (
    <>
      <section className="section" id="courses">
        <Container className="" id="instructors">
          {/* section title */}
          <SectionTitle title={header} desc={sub_header} />

          <Row className="justify-content-center">
            {/* teambox */}
            <TeamBox candidates={candidates} />
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Services
